import React, { Component } from 'react'
import { connect } from 'react-redux'

import TreeChild from 'components/Tree/TreeChild';
import TreeLayout from 'components/Tree/TreeLayout';

import { updateComponent, updateComponentContext, removeComponent,setComponentNames } from '_actions';

import { createId } from '../../assets/util'

import { sweetAlertActions } from "_actions";
import Emitter from "_actions/emitter";
import i18n from 'i18n';

import { ComponentService } from '_services';

import { ResponseStatusCode } from "_helpers";
import { Placeholder, Alert } from 'rsuite';




class GenerateTree extends Component {
    constructor(props) {
        super(props)

        this.state = {
            mantar: null,
            data: null,
        }
    }

    getComponentNames = async () => {
        const {setComponentNames}=this.props;
        await ComponentService.GetComponentNames(this.props.currentProjectId, this.props.currentPage).then(data => {
           if(data.operationResult){
            setComponentNames(data.dynamicValue);
           }
        }).catch(err => {
            debugger
            let data = { title: i18n.t("warning"), desc: ResponseStatusCode(err.statusCode) };
            Emitter.emit("SHOW_WARNING_MODAL", data);
            //Alert.error(data.dynamicValue)
            return null;
        });
    }
    componentDidMount = () => {
        this.restoreComponent();
        Emitter.on("handleNo", newValue =>
            Emitter.off("handleYes")
        );
    }
    componentWillUnmount() {
        Emitter.off("handleYes");
        this.setState = (state, callback) => {
            return;
        };
    }



    handleUpdateComponent = () => {
        if (!this.props.currentProjectId) { return }
        if (!this.props.pageStatus.status) { return }

        this.props.onUpdateConponent(this.props.data);
    }


    removeComponentDetailID = async (_newData) => {
        try {
            const { currentPage } = this.props;
            //komponent içerisinde ki id'ler oluşturuluyor.
            if (!this.props.currentProjectId) { return }
            if (!this.props.pageStatus.status) { return }
    
            let _newDataDetail = await this.convertComponentData(_newData);
            //debugger
            for (const item of _newDataDetail) {
    
                await ComponentService.RemoveComponentId(this.props.currentProjectId, currentPage, item.id).then(data => {
                    // console.log(item.id+" - SİLİNDİ")
    
                }).catch(err => {
                    debugger
                });
                try {
                    await this.generateNewID(item);
                } catch (error) {
                    
                }
            }
    
            return _newDataDetail;
        } catch (error) {
            return
        }
       

    }


    removeComponentId = () => {
        const { currentPage, component } = this.props;
        if (!this.props.currentProjectId) { return }
        if (!this.props.pageStatus.status) { return }


        try {
            ComponentService.RemoveComponentId(this.props.currentProjectId, currentPage, component.id).then(data => {
                // Alert.success("silindi");
                this.removeComponentDetailID(JSON.parse(JSON.stringify(component)));
                this.handleRemove()

            }).catch(err => {
                debugger
                let data = { title: i18n.t("warning"), desc: ResponseStatusCode(err.statusCode) };
                Emitter.emit("SHOW_WARNING_MODAL", data);
            });
        } catch (error) {
            debugger
        }

    }

    handleRemove = () => {


        const { data, index, baseProgress, isChild } = this.props;
        let newArray = Object.values(JSON.parse(JSON.stringify(baseProgress.baseArray)));// new Array(...baseProgress.baseArray); 
        // debugger
        newArray.splice(index, 1);
        this.props.removeComponent();
        try {this.getComponentNames()} catch (error) {debugger}

        baseProgress.handleUpdate(newArray);


    }

   
    convertComponentData = async (_newData) => {

        // fav komponent ve normal komponentler arasında model farklı olduğu için kontrol edilmesi gerekiyor.
        // data içeriği varsa geri dönüyor.
        try {
            if (_newData.hasOwnProperty("componentOwner")) {
                return _newData.object.components[0].object.hasOwnProperty("data") ? _newData.object.components[0].object.data : []
            } else {
                return _newData.components[0].object.hasOwnProperty("data") ? _newData.components[0].object.data : []
            }
        } catch (error) {
            return [];
        }



    }



    getObjects = async (obj, key, secondKey, ids) => {
        let _ids = ids;
        var objects = [];
        for (var i in obj) {
            if (!obj.hasOwnProperty(i)) continue;
            if (typeof obj[i] == 'object') {
                objects = objects.concat(await this.getObjects(obj[i], key, secondKey, _ids));
            } else if (i == secondKey) {
                //debugger
                obj[key] = _ids[0];
                _ids.shift();
            }
        }
        return obj;
    }

    removeAllIdObject = async (obj, key, secondKey) => {
        const that = this;

        var newValue = null;//await this.generateComponentId();
        var objects = [];
        for (var i in obj) {

            if (!obj.hasOwnProperty(i)) continue;
            if (typeof obj[i] == 'object') {
                objects = objects.concat(await this.removeAllIdObject(obj[i], key, secondKey));
            } else if (i == secondKey) {
                //debugger
                obj[key] = newValue;
            }

        }


        return obj;

    }
    generateComponentIdList = async (_count) => {
        return await ComponentService.GenerateComponentIdList(this.props.currentProjectId, this.props.currentPage, _count).then(data => {
            return data.dynamicValue;
        }).catch(err => {
            debugger
            let data = { title: i18n.t("warning"), desc: ResponseStatusCode(err.statusCode) };
            Emitter.emit("SHOW_WARNING_MODAL", data);
            //Alert.error(data.dynamicValue)
            return null;
        });
    }

    handleDublicate = async () => {
        // ilgili komponenti state içerisinde ki index +1 olarak klonlar
        const { data, index, baseProgress, isChild } = this.props;
        let newArray = Object.values(JSON.parse(JSON.stringify(baseProgress.baseArray)));// new Array(...baseProgress.baseArray); 

        let _newData = JSON.parse(JSON.stringify(newArray[index]));

        let _c = this.getPropValues(_newData, "componentName");
        let _ids = await this.generateComponentIdList(_c.length);
        _newData = await this.getObjects(_newData, "id", "componentName", _ids);


        newArray.splice(index, 0, _newData); // kopyalanan component
        try {this.getComponentNames()} catch (error) {debugger}

        baseProgress.handleUpdate(newArray);
    }

    handleKeyPress = (event) => {
        if (!this.props.currentProjectId) { return }

        if (!this.props.pageStatus.status) { return }

        if (event.keyCode == 46 || event.key == 'Delete') {

            Emitter.on("handleYes", newValue =>
                this.removeComponentId()
            );
            sweetAlertActions.SHOW_ASK(
                "",
                "",
                "",
                i18n.t("MESSAGE_DELETE_COMPONENT_FROM_EDITOR_SUBTITLE"),
                i18n.t("MESSAGE_DELETE_COMPONENT_FROM_EDITOR_SUCCESS"),
                i18n.t("MESSAGE_DELETE_COMPONENT_FROM_EDITOR_UNSUCCESS")
            );

        }
    }

    mouselog = (event) => {
        //  Mouse hover-leave aksiyonlarını yakamak için kullandığımız fonksiyon
        event.stopPropagation();
        // let d = new Date();
        //  let text = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()} | ${event.type} | ${this.props.data.name}`;

        if (event.type == "mouseover") {
            event.target.classList.add("component-hover");
        } else if (event.type == "mouseleave") {
            event.target.classList.remove("component-hover");

        } else {
            event.target.classList.remove("component-hover");

            //  text = event.type + ' !!!'
        }
        // console.log(text,event.target.classList);
    }

    childSizeProgress = (_item, _side) => {
        const _element = document.getElementsByClassName("deviceInside");
        //
        const _elementW = _element[0].offsetWidth + "px";
        const _elementH = _element[0].offsetHeight + "px";
        const _elementW2 = _element[0].offsetWidth / 2 + "px";
        const _elementH2 = _element[0].offsetHeight / 2 + "px";

        let _h = (_item.object.props.style.minHeight == "device" ? _elementH : (_item.object.props.style.minHeight == "half_device" ? _elementH2 : _item.object.props.style.minHeight));
        let _w = (_item.object.props.style.minWidth == "device" ? _elementW : (_item.object.props.style.minWidth == "half_device" ? _elementW2 : _item.object.props.style.minWidth));

        // debugger
        _h = _item.object.props.style.minHeight == "square" ? _w : _h;
        _w = _item.object.props.style.minWidth == "square" ? _h : _w;


        return _side == "w" ? _w : _h;

    }

    getPropValues = (o, prop) =>
        (res => (JSON.stringify(o, (key, value) =>
            (key === prop && res.push(value), value)), res))([]);



    handleGenerate = async () => {
        //Burada oluşturulan component Sayfanın main listesi index'i ne ait oluyor.

        const { index, baseProgress, isChild, path } = this.props;
        let __data = this.props.data;
        let data = __data;
 
        let _data;
        let _component;
        if (data.hasOwnProperty("componentOwner")) {

            _data = data.object.components[0].object;
            _component = data.object.components[0];
        } else {
            _data = data.components[0].object;
            _component = data.components[0];
        }


        let component = _data.type == "layout" ? TreeLayout : TreeChild;  // this.components[_data.type];

        if (!component) {
            // debugger
            Alert.error(i18n.t("VERSION_ERROR_NEW_COMPONENT"));
            return null;

        }

        let newComponent = React.createElement(component, {
            ...data.props,
            isChild: isChild,
            path,
            main: data,
            data: _data,
            index: index,
            baseProgress: baseProgress
        });


        const letrW = (_data.props.style.minWidth).match(/[a-zA-Z%]+/g)
        const letrH = (_data.props.style.minHeight).match(/[a-zA-Z%]+/g)

        return (
            <div
                className={(_data.type == "layout" || isChild == false) ? "dynamicComponent" : "dynamicSubComponent"}
            >
                {newComponent}
                <div
                    className={"dragableComponent"} tabIndex="1"
                    onFocus={() => { this.handleUpdateComponent() }}
                    onKeyDown={(event) => this.handleKeyPress(event)}
                    onMouseLeave={(event) => { this.mouselog(event) }}
                    onMouseOver={(event) => { this.mouselog(event) }}
                    onContextMenu={(e) => {
                        //debugger;
                        let obj = {
                            clientX: e.clientX,
                            clientY: e.clientY,
                            // target:e.target,
                        }
                        if (!this.props.currentProjectId) { return }
                        if (!this.props.pageStatus.status) { return }

                        this.props.onUpdateComponentContext(obj, this.handleRemove, this.handleDublicate);
                        e.preventDefault();
                    }}>
                    {
                        /*
                         <div className={"dragableComponentMore"} >
                        <div className={"dragableComponentInfo"}>
                            {data.name}
                        </div>
                        </div>
                        */
                    }
                </div>

            </div>
        )
    }

    restoreComponent = async () => {
        let _mantar = await this.handleGenerate();

        this.setState({
            mantar: _mantar,
            data: JSON.parse(JSON.stringify(this.props.data)),
        })
    }

    componentDidUpdate = (prevProps) => {
        const { component, data } = this.props;
        if (component) {
            if (component.id == data.id) {

                let _data;
                let _sData;

                if (data.hasOwnProperty("componentOwner")) {
                    _data = data.object.components[0];
                    _sData = this.state.data && this.state.data.object.components[0]
                } else {

                    _data = data.components[0];
                    _sData = this.state.data && this.state.data.components[0]
                }

                if (JSON.stringify(_data) != JSON.stringify(_sData)) {

                    this.restoreComponent();
                }
            }
        }

    }

    render() {
        const { mantar } = this.state;
        const { component, data } = this.props;

        return (
            <> 
            {
                /*
                  <div className={component && (component.id == data.id) ?"custom-tree-selected":"custom-tree"}>
                {mantar ? mantar : ""}
            </div>
                */
            }
                          {mantar ? mantar : ""}

            </>

           
        )
    }
}


const mapStateToProps = (state) => {
    const { editorReducer, componentReducer, currentstatesReducer } = state;
    const { present } = editorReducer;
    const { editor, pages, currentPage, page } = present;
    const { component, componentContext } = componentReducer;

    const { pageStatus, currentProjectId } = currentstatesReducer;

    return {
        currentPage,
        component,
        pageStatus,
        editor,
        currentProjectId
    };
}
const mapDispatchToProps = {
    onUpdateConponent: updateComponent,
    onUpdateComponentContext: updateComponentContext,
    removeComponent,
    setComponentNames
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateTree)
